import React, { useEffect, useRef } from "react";
import clsx from "clsx";

import { useChatContext } from "../context/ChatContext";

import { MarkdownRenderer } from "./MarkdownRenderer";

import styles from "../Styles.module.scss";

const EmptyState = () => (
  <div className={styles.chat_content}>
    <div className={styles.empty_state}>
      <div className={styles.assistant_title}>Design System Assistant</div>
      <div className={styles.assistant_subtitle}>What would you like to know?</div>
    </div>
  </div>
);

export function ChatMessages() {
  const { isOpen, messages } = useChatContext();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen || !containerRef.current) return;
    containerRef.current.scrollTop = containerRef.current.scrollHeight;
  }, [messages, isOpen]);

  if (!messages.length) return <EmptyState />;

  return (
    <div ref={containerRef} className={styles.chat_content}>
      <div className={styles.messages_list}>
        {messages.map((msg, i) => (
          <div
            key={i}
            className={clsx(
              styles.message,
              msg.role === "user" ? styles.user_message : styles.assistant_message
            )}
          >
            {msg.role === "assistant" ? (
              <MarkdownRenderer>{msg.content}</MarkdownRenderer>
            ) : (
              <span>{msg.content}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
